import script from "./AuthModalComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthModalComponent.vue?vue&type=script&setup=true&lang=ts"

import "./AuthModalComponent.vue?vue&type=style&index=0&id=33d6d7c3&lang=css"

const __exports__ = script;

export default __exports__